import axiosClient from "api/axios_client.js";

const apiCurrencyDirectory = {
  create: (payload) => axiosClient.post(`/directories/system-master/currency/create`, payload),
  update: (id, payload) => axiosClient.put(`/directories/system-master/currency/update/${id}`, payload),
  getById: (id) => axiosClient.get(`/directories/system-master/currency/get-by-id/${id}`),
  updateStatus: (payload) => axiosClient.post(`/directories/system-master/currency/update-status`, payload),
  getAllCurrency: (payload) => axiosClient.post(`/directories/system-master/currency/get-all`, payload),
  delete: (ids) => axiosClient.delete(`/directories/system-master/currency/delete`, { data: { ids } }),
};

export default apiCurrencyDirectory;
